<!-- Start progress bar-->
<!-- <mat-progress-bar
  color="primary"
  mode="indeterminate"
  *ngIf="spinnerService.visibility | async"
>
</mat-progress-bar> not working -->
<!-- End progress bar -->

<!-- Start sidenav container -->
<div
  #wrapper
  [dir]="'ltr'"
  class="wrapper menu-collapsed sidebar-sm"
  [ngClass]="{
    'nav-collapsed': hideSidebar}"
>
  <div
    #appSidebar
    appSidebar
    class="app-sidebar"
    (toggleHideSidebar)="toggleHideSidebar()"
    data-active-color="white"
    [attr.data-background-color]="'man-of-steel'"
    [attr.data-image]=""
    >
    <app-sidenav></app-sidenav>
  </div>
  <!-- Start toolbar-->
  <app-toolbar (toggleHideSidebar)="toggleHideSidebar()"></app-toolbar>
  <!-- End toolbar-->

  <div
    class="main-panel"
    [ngClass]="{
      'main-panel-sidebar-close': hideSidebar,
      'main-panel-sidebar-open': !hideSidebar
    }"
  >
    <div class="main-content">
      <div class="content-wrapper">
        <div
          class="container-fluid container-larger-size"
          [ngStyle.xs]="{ padding: '0px !important' }"
        >
          <router-outlet> </router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End sidenav container -->

<!--Chat Button-->
<div
  class="fab-container"
  ngClass.xs="fab-container-xs"
  ngClass.sm="fab-container-xs"
>
  <button
    mat-fab
    class="fab-toggler"
    matTooltip="Chat"
    (click)="showChat = !showChat; newMessages = 0"
  >
    <mat-icon
      class="material-icons"
      svgIcon="chat_btn"
      [matBadge]="newMessages <= 0 ? '' : newMessages"
    ></mat-icon>
  </button>
</div>
<!--End Chat Button-->

<!--CHAT CONTAINER-->
<div
  class="chat-container"
  [ngClass]="{
    'section-displayed': showChat === true,
    'section-off': showChat === false
  }"
>
  <app-chat
    (emitClose)="showChat = !showChat"
    (emitNewMessage)="setCounterNewMessages($event)"
  ></app-chat>
</div>
<!--END CHAT CONTAINER-->
